<template>
  <div class="graficodistribucionventas">
    <!-- Mapa -->
    <div class="panel panel-flat">
      <div class="panel-body" style="text-align: center;">
        <span style="font-weight: 700; font-size: 16px; font-family: arial;">Distribución de ventas</span>
        <vl-map
          :load-tiles-while-animating="true"
          :load-tiles-while-interacting="true"
          data-projection="EPSG:4326"
          style="height: 440px; padding-top: 10px;"
        >
          <!-- Mav view -->
          <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>
          <!-- /Mav view -->

          <!-- Map tile -->
          <vl-layer-tile id="bingmaps">
            <vl-source-bingmaps :api-key="apiKey" :imagery-set="imagerySet" :culture="culture"></vl-source-bingmaps>
          </vl-layer-tile>
          <!-- /Map tile -->

          <!-- Circulos -->
          <vl-feature v-for="ciudad in ciudades" :key="ciudad.prov" :id="ciudad.ciudad">
            <vl-geom-circle :radius="ciudad.ventas" :coordinates="ciudad.coor"></vl-geom-circle>
            <vl-style-box>
              <vl-style-stroke color="#359B35"></vl-style-stroke>
              <vl-style-fill color="#5AE45AAB"></vl-style-fill>
              <vl-style-text :text="String(ciudad.ventas)"></vl-style-text>
            </vl-style-box>
          </vl-feature>
          <!-- /Circulos -->

          <!-- interactions -->
          <vl-interaction-select :features.sync="selectedFeatures">
            <template slot-scope="select">
              <!-- select styles -->
              <vl-style-box>
                <vl-style-stroke color="#423e9e" :width="7"></vl-style-stroke>
                <vl-style-fill :color="[254, 178, 76, 0.7]"></vl-style-fill>
                <vl-style-circle :radius="5">
                  <vl-style-stroke color="#423e9e" :width="7"></vl-style-stroke>
                  <vl-style-fill :color="[254, 178, 76, 0.7]"></vl-style-fill>
                </vl-style-circle>
              </vl-style-box>
              <vl-style-box :z-index="1">
                <vl-style-stroke color="#d43f45" :width="2"></vl-style-stroke>
                <vl-style-circle :radius="5">
                  <vl-style-stroke color="#d43f45" :width="2"></vl-style-stroke>
                </vl-style-circle>
              </vl-style-box>
              <!--// select styles -->

              <!-- selected feature popup -->
              <vl-overlay
                class="feature-popup"
                v-for="feature in select.features"
                :key="feature.id"
                :id="feature.id"
                :position="pointOnSurface(feature.geometry)"
                :auto-pan="true"
                :auto-pan-animation="{ duration: 300 }"
              >
                <template>
                  <section class="card">
                    <header class="card-header">
                      <div class="row">
                        <div class="col-lg-1">
                          <div style="padding-top: 9px; padding-left: 5px;">
                            <a
                              class="card-header-icon"
                              title="Cerrar"
                              @click="selectedFeatures = selectedFeatures.filter(f => f.id !== feature.id)"
                            >
                              <span class="glyphicon glyphicon-remove"></span>
                            </a>
                          </div>
                        </div>
                        <div class="col-lg-11">
                          <span
                            class="card-header-title"
                          >{{ `${ciudadseleccionada.ciudad} (${ciudadseleccionada.prov})` }}</span>
                        </div>
                      </div>
                    </header>
                    <div class="card-content">
                      <div class>
                        <span>{{ `Ventas ${ciudadseleccionada.ventas}` }}</span>
                      </div>
                    </div>
                  </section>
                </template>
              </vl-overlay>
              <!--// selected popup -->
            </template>
          </vl-interaction-select>
          <!--// interactions -->
        </vl-map>
      </div>
    </div>
    <!--// Mapa -->
    <JqxChart
      style="width: 100%; height: 300px"
      :title="'Top 5 ventas en ciudades'"
      :description="'Estadísticas de 2019'"
      :enableAnimations="true"
      :showLegend="true"
      :padding="padding"
      :titlePadding="titlePadding"
      :source="ciudades"
      :xAxis="xAxisBH"
      :valueAxis="valueAxisBH"
      :seriesGroups="seriesGroupsBH"
      :colorScheme="'scheme01'"
    ></JqxChart>
  </div>
</template>
<script>
import JqxChart from "jqwidgets-scripts/jqwidgets-vue/vue_jqxchart.vue";
import { findPointOnSurface } from "vuelayers/lib/ol-ext";
import es_ciudades from "@/assets/data/ciudades/es.json";

export default {
  components: {
    JqxChart
  },
  data() {
    return {
      apiKey:
        "ArbsA9NX-AZmebC6VyXAnDqjXk6mo2wGCmeYM8EwyDaxKfQhUYyk0jtx6hX5fpMn",
      culture: "es-ES",
      imagerySet: "CanvasGray",
      lang: this.$store.getters.lang,
      zoom: 5,
      center: [-2.38, 40.16],
      rotation: 0,
      geolocPosition: undefined,
      selectedFeatures: [],
      pointOnSurface: findPointOnSurface,
      ciudadseleccionada: {},
      ciudades: [
        {
          prov: "Madrid",
          ciudad: "Madrid",
          ventas: 258600
        },
        {
          prov: "Álava",
          ciudad: "Vitoria-Gasteiz",
          ventas: 125000
        },
        {
          prov: "Alicante",
          ciudad: "Alicante",
          ventas: 85420
        },
        {
          prov: "Albacete",
          ciudad: "Albacete",
          ventas: 2360
        },
        {
          prov: "Almería",
          ciudad: "Almería",
          ventas: 1200
        }
      ],
      // Barras horizontales
      valueAxisBH: {
        flip: true,
        labels: {
          visible: true,
          formatFunction: value => {
            if (value === 0) {
              return String(0);
            } else if (value < 1000000) {
              return String(parseInt(value) / 1000 + "K");
            } else {
              return String(parseInt(value) / 1000000 + "M");
            }
          }
        }
      },
      xAxisBH: {
        visible: false,
        dataField: "ciudad",
        displayText: "ciudad"
      },
      seriesGroupsBH: [
        {
          type: "column",
          useGradient: false,
          orientation: "horizontal",
          columnsGapPercent: 50,
          toolTipFormatSettings: { thousandsSeparator: "." },
          series: [{ dataField: "ventas", displayText: "ventas" }]
        }
      ],
      padding: { left: 5, top: 5, right: 5, bottom: 5 },
      titlePadding: { left: 5, top: 5, right: 5, bottom: 5 }
      // /Barras horizontales
    };
  },
  watch: {
    selectedFeatures: {
      handler(n, o) {
        if (n !== o && n.length > 0) {
          this.findCiudad(n[0].id);
        }
      },
      deep: true
    }
  },
  created() {
    this.completarCoordenadas();
  },
  methods: {
    irA(direccion) {
      this.$router.push(direccion);
    },
    completarCoordenadas() {
      for (let i = 0; i < this.ciudades.length; i++) {
        const ciudad = this.ciudades[i];
        let ciudadAux = this.findCoordenada(ciudad);
        this.ciudades[i] = ciudadAux;
      }
    },
    findCoordenada(ciudad) {
      for (let j = 0; j < es_ciudades.length; j++) {
        const ciudadAux = es_ciudades[j];
        if (ciudad.ciudad.toLowerCase() === ciudadAux.city.toLowerCase()) {
          ciudad.coor = [Number(ciudadAux.lng), Number(ciudadAux.lat)];
          return ciudad;
        }
      }
    },
    findCiudad(nombre) {
      for (let i = 0; i < this.ciudades.length; i++) {
        let ciudad = this.ciudades[i];
        if (ciudad.ciudad === nombre) {
          this.ciudadseleccionada = ciudad;
          break;
        }
      }
    }
  },
  computed: {
    heightContent: function() {
      let heightTabla = 300;
      let alturaResto = 300;

      if (this.window.height < heightTabla + alturaResto) {
        return heightTabla;
      } else {
        return this.window.height - alturaResto;
      }
    }
  }
};
</script>

